import React from 'react';
import './Sidebar.css';
import { Avatar } from '@mui/material';
import { selectUser } from './features/userSlice';
import { useSelector } from 'react-redux';

function Sidebar() {
    const user = useSelector(selectUser); // Removed { user } destructuring — not needed here

    const recentItem = (topic) => (
        <div className='sidebar_recentItem'>
            <span className='sidebar_hash'>#</span>
            <p>{topic}</p>
        </div>
    );

    return (
        <div className='sidebar'>
            <div className='sidebar_top'>
                <img
                    src="https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80"
                    alt="cover"
                    className='sidebar_cover'
                />
                <Avatar
                    className='sidebar_avatar'
                    src={user?.photoUrl}
                >
                    {!user?.photoUrl && user?.email?.[0]?.toUpperCase()}
                </Avatar>
                <h2>{user?.displayName || 'Guest'}</h2>
                <h4>{user?.email || 'No email'}</h4>
            </div>

            <div className='sidebar_stats'>
                <div className='sidebar_stat'>
                    <p>Who viewed you</p>
                    <p className='sidebar_statNumber'>2,543</p>
                </div>
                <div className='sidebar_stat'>
                    <p>Views on post</p>
                    <p className='sidebar_statNumber'>1,069</p>
                </div>
            </div>

            <div className='sidebar_bottom'>
                <p>Recent</p>
                {recentItem('reactjs')}
                {recentItem('nextjs')}
                {recentItem('nodejs')}
                {recentItem('express')}
            </div>
        </div>
    );
}

export default Sidebar;
